// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c55ceb6b","455":"3264556c"}[chunkId] + ".chunk.js";
};